"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMagicLinkRequest = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const ResponseBase_1 = require("../../ResponseBase");
const AppLink_1 = require("../../utils/AppLink");
const Email_1 = require("../../utils/email/Email");
class SendMagicLinkRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsInstance)(Email_1.Email),
    (0, tslib_1.__metadata)("design:type", Email_1.Email)
], SendMagicLinkRequest.prototype, "email", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInstance)(AppLink_1.AppLink),
    (0, tslib_1.__metadata)("design:type", AppLink_1.AppLink)
], SendMagicLinkRequest.prototype, "redirectTo", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    (0, tslib_1.__metadata)("design:type", String)
], SendMagicLinkRequest.prototype, "businessId", void 0);
exports.SendMagicLinkRequest = SendMagicLinkRequest;
